import React from "react";

const SideImage: React.FC = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center bg-customBgGray h-full border rounded-lg">
      <img
        src="/gridImg.JPG"
        alt="Sample img"
        className="object-fill shadow-2xl xxl:h-96 lg:h-72 h-52 mt-10 border-2 border-black rounded-lg relative xxxl:bottom-20 bottom-8"
      />
      <div className="flex flex-col items-center mt-2 justify-center text-center xxxl:px-52 px-24">
        <p className="text-2xl font-helveticaBold font-bold">
          Welcome Back to Afrocart
        </p>
        <h4 className="mt-6 text-sm text-balance text-customGrayBase">
          Sign in to access your store dashboard and manage your products,
          orders, and more.
        </h4>
      </div>
    </div>
  );
};
export default SideImage;
